import { getFileUrlFromDriveInfo, globalGraphClient, getSessionIdFromDriveInfo } from "./GraphMain";
import { accessInfoType } from "../utils/classInfos";
import { formatDateTimeForCalendar } from "../utils/helper";
import { ExcelDateToJSDate, getSheetNameFromAddress } from "../utils/helperExcel";

function getRowValues(row, elements) {
  const modified = ExcelDateToJSDate(row[0]);
  const dateStr = formatDateTimeForCalendar(modified);
  const date = new Date(modified.valueOf()).setHours(0,0,0,0);
  const transactionId = row[1];
  const userId = row[2];
  const address = row[3];
  const oldValue = row[4];
  const newValue = row[5];
  const comment = row[6];
  const elementId = row[7];
  const worksheetId = row[8];
  const status = row[9];
  const processed = row[10];
  const worksheet = getSheetNameFromAddress(address);
  const elementName = (elements) ? elements.find((x) => x.id === elementId)?.name : elementId;
  // add a record
  const historyEntry = {
    modified: modified,
    dateStr: dateStr,
    date: date,
    transactionId: transactionId,
    userId: userId,
    address: address,
    oldValue: oldValue,
    newValue: newValue,
    comment: comment,
    elementId: elementId,
    elementName: elementName,
    worksheetId: worksheetId,
    worksheet: worksheet,
    status: status,
    processed: processed
  };
  return historyEntry;
}

export async function getHistoryFromDocument(accessInfo: accessInfoType, elements) {
  const tablesUrl = getFileUrlFromDriveInfo(accessInfo.driveItemInfo) + "/workbook/tables/AR_LOG/rows";
  const sessionId = await getSessionIdFromDriveInfo(accessInfo.driveItemInfo);
  let history = [];

  try {
    let tableInfo = await globalGraphClient
      .api(tablesUrl)
      .header("workbook-session-id", sessionId)
      .get();
    // get the helper tables
    tableInfo.value.forEach((log) => {
      const row = log.values[0];
      // values
      const historyEntry = getRowValues(row, elements);
      history.push(historyEntry);
    })}
  catch (err) {
    console.log("ERROR getHistoryFromDocument", err);
  }
  return history;
}

export async function getHistoryForElement(accessInfo: accessInfoType, elementId: string) {
  let history = [];
  if (!globalGraphClient) return history;

  const tablesUrl = getFileUrlFromDriveInfo(accessInfo.driveItemInfo) + "/workbook/tables/AR_LOG/rows";
  const sessionId = await getSessionIdFromDriveInfo(accessInfo.driveItemInfo);

  try {
    let tableInfo = await globalGraphClient
      .api(tablesUrl)
      .header("workbook-session-id", sessionId)
      .get();
    // get the helper tables
    tableInfo.value.forEach((log) => {
      const row = log.values[0];
      const changeElementId = row[7];
      const changeWorksheetId = row[8];
      const isRelevant = (changeElementId === elementId || changeWorksheetId === elementId);

      if (isRelevant === true) {
        // values
        const historyEntry = getRowValues(row, null);
        history.push(historyEntry);
      }
    })}
  catch (err) {
    console.log("ERROR getHistoryForElement", err);
  }

  return history;
}

